export default function addCompareSlug(slug, add) {
    slug.push(add);
    return slug.join("-vs-");
}